import type { HotelListData } from '@/interfaces/components/hotelListData';
import type { ApiDataTypesKeys } from '../types';
import type { GeoInventoryResponse } from '@/interfaces/api/v1-geo-inventory';
import request from '@components/common/services/request';

export function createExcludeAndBodyParams(hotelListData: HotelListData, travelType: 'Accommodation' | 'Package') {
	const listType = hotelListData.locationType;
	const exclude: ApiDataTypesKeys[] = travelType === 'Accommodation' ? ['DepartureAirport', 'DirectFlight', 'Transfer'] : [];
	exclude.push('DefiniteStartDate', 'SortOrder', 'HotelIffCode');

	if (listType === 'COUNTRY') {
		exclude.push('Regions', 'Cities');
	}
	if (listType === 'TOPREGION' || listType === 'CITY') {
		exclude.push('Cities');
	}
	if (listType === 'REGIONGROUP') {
		exclude.push('Regions', 'Cities');
	}
	const bodyParams = {
		travelType: travelType,
		regionGroupIds: listType === 'REGIONGROUP' && hotelListData.rlId ? [parseInt(hotelListData.rlId, 10)] : [],
		locationId: listType === 'COUNTRY' ? [hotelListData.locationId] : [],
		rid: listType === 'TOPREGION' || listType === 'CITY' ? [parseInt(hotelListData.rid, 10)] : [],
	};

	return { bodyParams, exclude };
}

export function fetchDestinations<TData>(data: TData, url: string) {
	return request<GeoInventoryResponse | []>({ url, data }, 'geoOperator');
}
